import { defineStore } from 'pinia';

export const usePriceStore = defineStore('prices', {
  state: () => {
    return {
      errors: {},
      price: {},
      prices: [],
      users: [],
      pagination: {},
    };
  },

  actions: {
    async index(params) {
      if (params && params.includes('filter')) {
        return await this.axios.get(`/prices?${params}`).then((res) => {
          this.prices = res.data.data;
        });
      } else {
        return await this.axios.get('/prices').then((res) => {
          this.prices = res.data.data;
        });
      }
      // return await this.axios.get('/prices').then((res) => {
      //   this.prices = res.data.data;
      // });
    },
    async show(id) {
      this.errors = {};
      this.price = {};
      return this.axios.get(`/prices/${id}`).then((res) => {
        this.price = res.data.data.attributes;
        return res.data.data.attributes;
      });
    },
    async new() {
      this.errors = {};
      this.price = {};
      return this.axios.get(`/prices/new`).then((res) => {
        this.price = res.data.data.attributes;
      });
    },
    async create() {
      this.errors = {};
      return this.axios
        .post(`/prices`, this.price)
        .then((res) => {
          this.price = res.data.data.attributes;
          return true;
        })
        .catch((error) => {
          this.errors = error.res.data.errors;
          return false;
        });
    },
    async edit(id) {
      this.errors = {};
      this.price = {};
      return this.axios.get(`/prices/${id}/edit`).then((res) => {
        this.price = res.data.data.attributes;
      });
    },
    async update(id) {
      this.errors = {};
      // console.log(this.price);
      return this.axios
        .put(`/prices/${id}`, this.price)
        .then((response) => {
          return true;
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
          return false;
        });
    },
    async updateAll() {
      this.errors = {};
      this.prices = [];
      return await this.axios
        .put(`/prices/update_credit`, this.price)
        .then((res) => {
          this.prices = res.data.data;
          return true;
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
          return false;
        });
    },
    async getUsers() {
      this.errors = {};
      this.users = [];
      return await this.axios
        .get(`/prices/users`, this.price)
        .then((res) => {
          this.users = res.data.data;
          return res.data.data;
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
          return false;
        });
    },
    async destroy(id) {
      this.errors = {};
      return this.axios
        .delete(`/prices/${id}`)
        .then((response) => {
          return true;
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
          return false;
        });
    },
  },
});
